import { render } from "./ShippingDeliveryPolicyPage.vue?vue&type=template&id=644ab520&ts=true"
import script from "./ShippingDeliveryPolicyPage.vue?vue&type=script&lang=ts"
export * from "./ShippingDeliveryPolicyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__